mainApp.directive('docDataTableHeader', function() {
    return {
        templateUrl: '/public/components/discovery/doc-data-table-header.directive.html',
        restrict: 'A',
        link: function(ctrl, el, attrs) {

            ctrl.fieldsSpec = ctrl.$eval(attrs.fieldsSpec);

            ctrl.sortFields = ctrl.$eval(attrs.sortFields);

            ctrl.selectedFields = ctrl.$eval(attrs.selectedFields);

            ctrl.removeColumn = function(field) {
                ctrl.$eval(attrs.onColumnRemove, {field: field});
            }

            ctrl.moveColumn = function(field, direction) {
                ctrl.$eval(attrs.onColumnMove, {field: field, direction: direction});
            }

            ctrl.toggleSort = function(field) {
                ctrl.$eval(attrs.onColumnSort, {field: field});
            }

            ctrl.getFieldSortOrder = function(field) {
                if (ctrl.sortFields[0] && ctrl.sortFields[0].field === field)
                    return ctrl.sortFields[0].order;
                return 'asc';
            }

            ctrl.isSortedByField = function(field) {
                return ctrl.sortFields[0] && ctrl.sortFields[0].field === field;
            }

            ctrl.canMoveToLeft = function(field) {
                return ctrl.selectedFields.indexOf(field) > 1;
            }

            ctrl.canMoveToRight = function(field) {
                return ctrl.selectedFields.indexOf(field) < ctrl.selectedFields.length - 1;
            }
        }
    }
});